import {Component, Input, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'esp-single-select-item',
  templateUrl: './single-select-item.component.html',
  styleUrls: ['./single-select-item.component.css']
})
export class SingleSelectItemComponent implements OnInit {

  @Input() item;
  constructor() { }

  ngOnInit(): void {
  }

}
